import {HttpInterceptorFn} from '@angular/common/http';
import {inject} from '@angular/core';
import {catchError, switchMap, tap} from 'rxjs/operators';
import {from, throwError} from 'rxjs';
import {UtilityService} from '../services/utility.service';
import {UTILITY} from '../components/utility/utility.component';
import {environment} from '../../environments/environment';
import {AuthService} from '../services/auth.service';

const shortLoadingList = [
    environment.AFFILIATE_TAG_GET_ALL,
    environment.MAINTENANCE_GET,
    environment.UPDATE_APP_GET,
    environment.DEAL_COMMENT_GET_ALL_NO_LOADING,
    environment.DEAL_GET_BY_ID,
    environment.DEAL_LIKE_CREATE,
    environment.DEAL_LIKE_DELETE,
    environment.DEAL_COMMENT_LIKE_CREATE,
    environment.DEAL_COMMENT_LIKE_DELETE,
    environment.COMMUNICATION_GET_ALL_FIRST_ACCESS,
    environment.COMMUNICATION_LIKE_CREATE,
    environment.COMMUNICATION_LIKE_DELETE,
    environment.COMMUNICATION_COMMENT_LIKE_CREATE,
    environment.COMMUNICATION_COMMENT_LIKE_DELETE,
    environment.TUTORIAL_GET_ALL_FIRST_ACCESS,
    environment.TUTORIAL_LIKE_CREATE,
    environment.TUTORIAL_LIKE_DELETE,
    environment.TUTORIAL_COMMENT_LIKE_CREATE,
    environment.TUTORIAL_COMMENT_LIKE_DELETE,
    environment.NOTIFICATION_GET_ALL_FIRST_ACCESS,
    environment.AFFILIATE_TAG_GET_ALL_FIRST_ACCESS,
    environment.IN_EVIDENCE_GET_ALL_FIRST_ACCESS,
    environment.USER_LIKE_GET_ALL
];

export const apiInterceptor: HttpInterceptorFn = (initialReq, next) => {
    const utilityService = inject(UtilityService);
    const authService = inject(AuthService);

    const shouldShortLoadOpen = shortLoadingList.some(link => initialReq.url.includes(link));
    if (!UTILITY.checkObj(shouldShortLoadOpen)) {
        utilityService.valueOfLoading(1);
    }

    return from(authService.hasValidToken()).pipe(
        switchMap((isLoggedIn) => {
            let req = initialReq;

            if (isLoggedIn) {
                return from(authService.getToken()).pipe(
                    switchMap((token) => {
                        if (token) {
                            req = req.clone({
                                setHeaders: {Authorization: `Bearer ${token}`}
                            });
                        }
                        return next(req);
                    })
                );
            } else {
                return next(req);
            }
        }),
        tap(() => {
            const shouldShortLoadClose = shortLoadingList.some(link => initialReq.url.includes(link));
            if (!UTILITY.checkObj(shouldShortLoadClose)) {
                setTimeout(() => {
                    utilityService.valueOfLoading(-1);
                }, 300);
            }
        }),
        catchError((error) => {
            setTimeout(() => {
                utilityService.valueOfLoading(-1);
            }, 300);
            return throwError(() => error);
        })
    );
};
